// Fallback for unmapped device types — builds generic on/off buttons from the
// device's outputs (mirrors the Flutter UnsupportedDeviceScreen).

import React, { useEffect, useState } from 'react';
import { Card, Box, Typography, Switch, Stack } from '@mui/material';
import DeviceShell from '../../components/DeviceShell';
import { useApp } from '../../../../core/state/AppContext';
import { useDeviceStatus } from '../../../../core/mqtt/useDeviceStatus';
import { publishCommand } from '../../../../core/utils/deviceController';

export default function UnsupportedScreen({ device, outputs, initialStatus = '' }) {
  const { userId } = useApp();
  const uno = device.UniqueNumber;
  const [status] = useDeviceStatus(uno, initialStatus);
  const [states, setStates] = useState({});

  useEffect(() => {
    if (status) {
      const parts = status.split(',');
      const map = {};
      outputs.forEach((o, i) => { map[o.Output] = parts[i] === '1'; });
      setStates(map);
    }
  }, [status, outputs]);

  // The UI never guesses — publish, and let the device's echo (the effect
  // above) move the switch. See core/hooks/useRelayStatus for the rule and
  // DeviceControlCard's `toggle` for why the optimistic flip was a fault.
  const toggle = (output) => {
    publishCommand(uno, `${output}-${states[output] ? 0 : 1}`, userId);
  };

  return (
    <DeviceShell title={device.DeviceName || uno}>
      {outputs.length === 0 ? (
        <Typography color="text.secondary">No controllable outputs found.</Typography>
      ) : (
        <Stack spacing={2}>
          {outputs.map((o) => (
            <Card key={o.Output} sx={{ bgcolor: 'primary.main', p: 2, borderRadius: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ flex: 1, color: 'primary.contrastText' }}>
                  {o.OutputName || `Output ${o.Output}`}
                </Typography>
                <Switch checked={!!states[o.Output]} onChange={() => toggle(o.Output)} />
              </Box>
            </Card>
          ))}
        </Stack>
      )}
    </DeviceShell>
  );
}
